export default {
  accommodationUnitSingular: 'room',
  accommodationUnitPlural: 'rooms',
  AccommodationUnitSingular: '@.capitalize:accommodationUnitSingular',
  AccommodationUnitPlural: '@.capitalize:accommodationUnitPlural',

  fullstop: '.', // used as linked messages for formatting
  comma: ',', // used as linked messages for formatting
  failed: 'Action failed',
  success: 'Action was successful',
  actions: {
    ok: 'Ok',
    cancel: 'Cancel',
    continue: 'Continue',
    search: 'Search',
    close: 'Close',
    next: 'Next',
    back: 'Back',
    done: 'Done',
    yes: 'Yes',
    no: 'No',
    save: 'Save',
    create: 'Create',
    upload: 'Upload',
    complete: 'Complete',
    reset: 'Reset',
    addNewRoom: 'Add new @:accommodationUnitSingular',
    viewOffer: 'View offer',
    editSearch: 'Edit Search',
    allRates: 'All Rates',
    select: 'Select',
    selectRate: 'Select Rate',
    selected: 'Selected',
    choose: 'Choose',
    chooseStay: 'Choose Stay',
    delete: 'Delete',
    add: 'Add',
    bookNow: 'Book now',
    checkout: 'Checkout',
    confirmBooking: 'Confirm Booking',
    createAccount: 'Create Account',
    guestCheckout: 'Guest Checkout',
    login: 'Login',
    readmore: 'Read more',
    viewAllRates: 'View all Rates',
    viewAvailabilityCalendar: 'View Full Availability',
    upgrade: 'Upgrade',
    resetPassword: 'Reset Password',
    update: 'Update',
    emailLink: 'Email link',
    register: 'Register',
    ratesAndAvailability: 'See Rates And Availability',
    start: 'Start',
    finish: 'Finish',
  },
  errorHeaders: {
    notFound: 'Not found',
    error: 'Error',
    unauthorised: 'Unauthorised',
    warning: 'Warning',
  },
  reservation: {
    createdSuccessMessage: 'Booking has been made successfully.',
  },
  user: {
    loginSuccessMessage: 'Welcome back, {name}',
    loginErrorMessage:
      'Failed to login, please check your email address and password',
    registerSuccessMessage:
      'User registration successful, please check your email address to confirm your account.',
    registerErrorMessage: 'Failed to register User',
    logoutSuccessMessage: 'You have been successfully logged out.',
  },
  navigationControl: {
    title1: 'Your search',
    title2: '@.capitalize:accommodationUnitPlural & Rates',
    title3: 'Checkout',
  },
  giftServiceProvider: {
    voucherCodeLabel: '{name} voucher code',
    enterVoucherCode: 'Enter your voucher code',
    voucherCodeEntered: '{name} voucher code entered',
    discount: 'Discount',
    voucherCodeAppliedLabel: '{name} Voucher applied',
    validating: 'Validating...',
  },
  search: {
    title: 'Book your stay',
    promoCodeLabel: 'Promo code',
    enterPromoCode: 'Enter your @:search.promoCodeLabel',
    promoCodeEntered: 'Code entered',
    chooseDates: 'Choose your dates',
    chooseRooms: 'Choose your @:accommodationUnitPlural',
    addGuests: 'Add your guests',
    ourLocations: 'Our locations',
    exploreOffers: 'Explore Offers',
    chooseArea: 'Choose area',
  },
  roomsAndRates: {
    title: '@.capitalize:accommodationUnitPlural & Rates',
    roomSelectionAvailableHeadline: 'Good news!',
    roomSelectionPositiveBadge: 'Your selection is available',
    roomSelectionNotAvailableHeadline:
      'Sorry, your selection is not available.',
    roomSelectionNegativeBadge:
      'No @:accommodationUnitPlural available on selected dates',
    roomSelectionNotAvailableMessage:
      'Please see alternative stays and availability below',
    chooseYourRate: 'Choose your Rate',
    roomTypeDescriptionLabel: 'Description & Highlights',
    alternativeStays: 'Alternative Stays',
    minimumLengthOfStayHeader: 'Minimum Length of Stay',
    minimumLengthOfStayBadge: '{miniumLengthOfStay} night minimum stay',
    availabilityCalendar: 'Availability Calendar',
    upgrades: 'Upgrades',
    notEnoughRoomsBasedOnOccupancy:
      'Your combination of @:accommodationUnitPlural is not available, please retry your search or contact us directly to make your booking',
  },
  upgrades: {
    title: 'Upgrades',
    currentSelection: 'Your current selection',
  },
  checkout: {
    title: 'Checkout',
    yourDetails: 'Your Details',
    paymentDetails: 'Payment Details',
    organisationPaymentDetails: 'Organisation Payment Details',
    createAccount: 'Create Account',
    billingDetails: 'Your billing address',
    additionalInformation: 'Additional Information',
  },
  confirmation: {
    title: 'Confirmation',
    successMessage: 'Your booking is confirmed',
    thankYouMessage: '{firstName}@:comma thank you for choosing {locationName}',
    bookingConfirmationEmailMessage:
      'You will receive a confirmation email of your booking shortly',
    reservationMessage: 'Your reservation number is {reservationNumber}',
    mobileBookingConfirmationDetailsMessage:
      'You can check your booking details below',
    desktopBookingConfirmationDetailsMessage:
      'You can review your booking details to the left',
    bookingSummary: 'Booking Summary',
    whatsNext: "What's next?",
    buttons: {
      bookATable: 'Book a Table',
      manageBooking: 'Manage Booking',
      addExtras: 'Add Extras',
      printConfirmation: 'Print Confirmation',
      bookAnotherRoom: 'Book another @:accommodationUnitSingular',
      backToHotelWebsite: 'Back to Hotel Website',
    },
  },
  account: {
    createAccountTitle: 'Create Account',
    loginLabel: 'Login',
    loginTitle: 'Login',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    passwordIsRequired: 'Password is required',
    passwordHint:
      'Your password should be ten characters or more and contain at least 1 non alpha numeric character.',
    confirmPasswordHint: 'Please confirm your password',
    forgotPasswordLink: 'Forgot your password?',
    forgotPasswordHeader: 'Forgot Password',
    forgotPasswordInstructions:
      'Please enter your registered email address below. An email will be sent to you containing a link which will enable you to reset your password.',
    resetPasswordHeader: 'Reset your Password',
    resetPasswordInstructions: 'Enter your new password below',
    confirmEmail: 'Confirm Email',
    confirmEmailSucccessHeader: 'Email Address Confirmed',
    confirmEmailSucccessMessage:
      'Your email address was successfully confirmed. You can now login via the login page.',
    manageAccount: 'Manage Account',
    changePassword: 'Change Password',
    failedToResetPasswordErrorMessage: 'Failed to reset your password',
    resetYourPasswordConfirmation: 'Your password has been successfully reset.',
    updatedUserSuccessfully: 'Your details have been saved successfully.',
    failedToUpdateUser: 'Failed to save your details',
    passwordResentSent:
      'Please check your email for a link to reset your password.',
    passwordResetEmailSentSuccessfully:
      'Password Reset Email sent successfully.',
    failedToSendPasswordReset: 'Failed to send Password Reset Email',
    register: 'Create Account',
    registerConfirmation:
      'Your account has been created. Please check your email to confirm your account.',
    failedToRegisterUser: 'Failed to create user account',
    userRegisteredSuccessfully: 'Your account has been created',
  },
  footer: {
    label: 'Powered by',
    url: 'hopsoftware.com',
    copyright: '© 2024 Hop Software Ltd',
  },
  contactUs: {
    label: 'Contact Us',
    title: 'Contact Us',
  },
  menu: {
    contactUs: 'Contact Us',
    manageAccount: 'Manage Account',
    login: 'Login',
    logout: 'Logout',
  },
  restaurantService: {
    title: 'Book a Table',
    bookTable: 'Book Table',
    failedToCreateBooking: 'Failed to create booking',
    successfullyCreateBooking: 'Table booking created.',
    createdBookingHeader: 'Your table booking has been created.',
    createdBookingMessage: 'Your booking reference is {bookingReference}.',
    Restaurant: 'Restaurant',
    VisitDate: 'Date',
    VisitTime: 'Time',
    PartySize: 'Party Size',
    EmailAddress: 'Email Address',
    ContactNumber: 'Contact Number',
    SpecialRequests: 'Special Requests',
    Promotion: 'Promotion',
  },
  company: 'Company',
  poNumber: 'PO Number',
  noResultsFound: 'No Results found',
  failedToSearchForCompanies: 'Error while searching for Companies',
  maxNumberOfRoomsOnBookingExceededHeader:
    'You have added the maximum number of @:accommodationUnitPlural',
  maxNumberOfRoomsOnBookingExceededBadge: 'Maximum @:accommodationUnitPlural',
  maxNumberOfRoomsOnBookingExceededMessage:
    'If you wish to add more @:accommodationUnitPlural@:comma please contact us directly and we will be happy to assist you.',
  sameDayBookingsHeader: 'No same day bookings available',
  roomHeader: '@.capitalize:accommodationUnitSingular {roomNumber}',
  roomDescription: '@.capitalize:accommodationUnitSingular Description',
  activeRoomSelectionTitle:
    'Choose @.capitalize:accommodationUnitSingular {roomNumber}',
  roomTypeSelectionHeader:
    'Selecting \n @.capitalize:accommodationUnitSingular {roomNumber}',
  highlights: 'Highlights',
  rateInformation: 'Rate Information',
  policyInformation: 'Policy Information',
  night: 'night',
  nights: 'nights',
  room: '0 accommodationUnitPlural | 1 @:accommodationUnitSingular | {n} @:accommodationUnitPlural',
  rooms: '@:accommodationUnitPlural',
  Room: '@:AccommodationUnitSingular',
  Rooms: '@:AccommodationUnitPlural',
  guest: '0 guests | guest | {n} guests',
  guests: 'guests',
  Guest: '0 Guests | Guest | {n} Guests',
  Guests: 'Guests',
  adult: '0 adults | adult | {n} adults',
  adults: 'adults',
  Adult: '@.capitalize:adult',
  Adults: '@.capitalize:adults',
  child: '{n} child | {n} children',
  children: 'children',
  Child: '@.capitalize:child',
  Children: '@.capitalize:children',
  infant: 'infant',
  infants: 'infants',
  Infant: '@.capitalize:infant',
  Infants: '@.capitalize:infants',
  from: 'from',
  perNight: 'Per night',
  remaining: 'remaining',
  was: 'was',
  totalStayFrom: 'Total stay from',
  totalFrom: 'Total from',
  total: 'Total',
  leadOccupantHeader: 'Lead Occupant Details',
  leadOccupant: 'Lead Occupant',
  bedSetupHeader: 'Bed Setup',
  bedConfigurationLabel: 'Bed Configuration',
  firstName: 'First Name',
  lastName: 'Last Name',
  optionalExtras: 'Optional Extras',
  quantity: 'Quantity',
  bookYourStay: 'Book your Stay',
  bookingSummary: 'Booking Summary',
  yourStay: 'Your Stay',
  extras: 'Extras',
  extra: 'Extra',
  save: 'Save',
  bookingDetails: 'Booking Details',
  yourEmail: 'Your Email',
  email: 'Email',
  validEmailRequired: 'A valid email address is required',
  phoneNumber: 'Phone Number',
  validPhoneNumberRequired: 'A valid phone number is required',
  phoneNumberHint:
    'Please include the international dialing code with your number starting with + or 00',
  postCode: 'Post Code',
  street: 'Street',
  country: 'Country',
  stateOrCounty: 'State', // TODO Change name based on config settings
  city: 'City',
  optInUpdatesLabel: 'Join our mailing list',
  optInUpdatesMessage:
    'Keep in touch with us to receive exclusive discounts and offers',
  viewPrivacyPolicy: 'View Privacy Policy',
  specialRequestsLabel: 'Any special requests?',
  commentLabel: 'Who referred you to us?',
  cardHolderName: 'Card Holder Name',
  cardHolderEmail: 'Card Holder Email',
  cardType: 'Card Type',
  cardNumber: 'Card Number',
  expiryMonth: 'Expiry Month',
  expiryYear: 'Expiry Year',
  cvv: 'CVV',
  termsAndConditionsLabel: 'By continuing, you agree to the ',
  termsAndConditionsText: 'Terms and Conditions',
  miniumNightStayBadge: '{numberOfNights} night minimum',
  miniumNightStayBadgeSuffix: ' on selected check-in date',
  saveCardForFutureUseLabel: 'Save card for future use?',
  scanCard: 'Scan Card',
  propertyGroup: {
    noAvailabilityMessage: 'This hotel is unavailable on your selected dates.',
  },
  bookingIncentivesHeader: 'Why Book with Us?',
  bookingIncentivesLabel: 'Why Book with Us?',
  bookingIncetivesMessage:
    'By booking direct, you can take advantage of the following benefits...',

  propertyGroupSearch: {
    noRoomsFound: 'No rooms found',
  },

  occupancyDisplay: {
    maxOnly: 'Sleeps up to {guestValue}',
    adultsOnly: 'Sleeps up to {adultValue}@:fullstop',
    maxAndAdults:
      'Sleeps up to {adultValue}@:comma with a total capacity of {guestValue}@:fullstop',
    adultsAndChildren:
      'Sleeps {adultValue}@:comma with space for up to {childValue}@:fullstop',
    adultsChildrenAndMax:
      'Sleeps {adultValue}@:comma with space for up to {childValue}@:comma for a total maximum of {guestValue}@:fullstop',
  },

  preCheckIn: {
    title: 'Pre Check In',
    saluation: 'Dear',
    errorHeader: 'Pre Check In Error',
    invalidLinkMessage:
      'This link is invalid. Please re check the link is correct and try again.',
    welcomeMessage:
      'We look forward to welcoming you on {arrivalDate} for your {numberOfNights} stay. For a smoother arrival and to minimise queueing, please complete your guest registration.',
    booker: 'Booker',
    guest: 'Guest',
    account: 'Account',
    name: 'Name',
    reservationNumber: 'Reservation',
    arrivalDate: 'Arrival Date',
    departureDate: 'Departure Date',
    roomType: 'Room Type',
    ratePlan: 'Rate Plan',
    totalCostOfStay: 'Total Cost Of Stay',
    bookerDetails: 'Booker Details',
    roomDetails: 'Room Details',
    extras: 'Extras',
    summary: 'Summary',
    bookingSummary: 'Booking Summary',
    specialRequests: 'Special Requests',
    completeHeader: 'Thank you',
  },

  buttons: {
    bookAnotherRoom: 'Book another @:accommodationUnitSingular',
    backToHotelWebsite: 'Back to Hotel Website',
  },
};
